import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Social } from './components/Social';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/Shared';
const FB_PIXEL_ID = '1545009850674181';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: unknown;
    };
    _fbq?: unknown;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Skip pixel inside the Magic Patterns preview iframe to avoid CORS / sandbox errors.
    // The pixel will still run on the published live site (top-level window).
    try {
      if (window.self !== window.top) return;
    } catch {
      return; // accessing window.top can throw in sandboxed contexts
    }
    try {
      if (window.fbq) {
        window.fbq('track', 'PageView');
        return;
      }
      /* eslint-disable */
      ;
      (function (f: any, b: any, e: any, v: any) {
        let n: any, t: any, s: any;
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        t.onerror = function () {
          /* swallow load errors silently */
        };
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
      window.fbq?.('init', FB_PIXEL_ID);
      window.fbq?.('track', 'PageView');
    } catch {
      /* fail silently — never let pixel errors break the page */
    }
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-terracotta/30" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>

      <Hero data-id="element-3" />
      <Problem data-id="element-4" />
      <Product data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Pricing data-id="element-7" />
      <Social data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}